/** Retain the request identity after an uncertain response, including form remounts. */
let attempts = new Map<string, string>();
let storageKey = "";
function persist() {
  if (!storageKey) return;
  try { sessionStorage.setItem(storageKey, JSON.stringify([...attempts])); } catch { /* Memory retry remains available when browser storage is blocked. */ }
}
export function setCommandScope(userId: string) {
  const next = `estet:pending-commands:${userId}`;
  if (storageKey === next) return;
  storageKey = next; attempts = new Map();
  try {
    const saved: unknown = JSON.parse(sessionStorage.getItem(storageKey) || "[]");
    if (Array.isArray(saved)) for (const row of saved) {
      if (Array.isArray(row) && row.length === 2 && row.every(value => typeof value === "string")) attempts.set(row[0], row[1]);
    }
  } catch { /* A corrupt local cache must not break login. */ }
}

export function canonical(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonical).join(",")}]`;
  if (value && typeof value === "object") return `{${Object.entries(value).filter(([, v]) => v !== undefined).sort(([a], [b]) => a.localeCompare(b)).map(([k, v]) => `${JSON.stringify(k)}:${canonical(v)}`).join(",")}}`;
  return JSON.stringify(value) ?? "null";
}
export function commandIdentity(path: string, payload: Record<string, unknown>) {
  const fingerprint = `${path}:${canonical(payload)}`;
  let id = attempts.get(fingerprint);
  if (!id) { id = crypto.randomUUID(); attempts.set(fingerprint, id); persist(); }
  return { id, fingerprint };
}
export function commandAccepted(fingerprint: string) { attempts.delete(fingerprint); persist(); }
export function clearCommandIdentities() { attempts.clear(); if (storageKey) { try { sessionStorage.removeItem(storageKey); } catch { /* Private mode. */ } } storageKey = ""; }
